import { render, staticRenderFns } from "./comp_dpc-SliderPlusFeatured.vue?vue&type=template&id=268c4976&scoped=true&"
import script from "./comp_dpc-SliderPlusFeatured.vue?vue&type=script&lang=js&"
export * from "./comp_dpc-SliderPlusFeatured.vue?vue&type=script&lang=js&"
import style0 from "./comp_dpc-SliderPlusFeatured.vue?vue&type=style&index=0&id=268c4976&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268c4976",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
